<template>
  <div>
    <v-card
      :loading="loading"
      class="blueCard mb-6 d-flex flex-row flex-wrap"
      flat
      ><div class="pa-4 text-h4">Billing Protocols</div>
      <v-spacer> </v-spacer>
      <v-btn
        v-if="!$vuetify.breakpoint.smAndUp"
        @click="toggleExpandAll()"
        depressed
        rounded
        x-small
        class="ma-2"
        ><v-icon class="mr-2" x-small>{{
          expandAll ? "mdi-arrow-collapse" : "mdi-arrow-expand"
        }}</v-icon>
        {{ expandAll ? "Collapse" : "Expand" }} All</v-btn
      >
    </v-card>

    <v-skeleton-loader
      v-if="loading && !protocols"
      class="mx-auto"
      type="list-item, list-item-three-line, list-item-three-line, list-item-three-line,list-item,  list-item-three-line"
    ></v-skeleton-loader>

    <div v-if="protocols">
      <div
        v-for="(table, i) in protocols"
        :key="i"
        class="mb-2 mb-sm-8 mx-0 mx-sm-2"
        :id="table.slug"
      >
        <!-- {{ table }} -->

        <!--  <h2>
        
         {{ table.name }} 
        </h2>-->
        <responsive-table
          :headers="table.headers"
          :groups="table.groups"
          :title="table.title"
          :notes="table.notes"
          :notesClass="null"
          :titleType="$vuetify.breakpoint.smAndUp ? 'header' : 'collapsible'"
          :expandAll="expandAll || $vuetify.breakpoint.smAndUp"
        >
          <template #image>
            <v-img
              v-if="table.image"
              :src="imgPath + table.image"
              contain
              height="40px"
              max-width="100px"
              class="pr-3 whiteBox"
            ></v-img>
          </template>
        </responsive-table>
        <!-- {{ table.groups }} -->
      </div>
      <div id="protocols-disclaimer"></div>
      <v-card flat style="margin-top: 60px" color="#fff7e5">
        <v-card-title>Disclaimer</v-card-title>
        <v-card-text>
          <page
            articleSlug="protocols-disclaimer"
            :showHeader="false"
            :showSubscribeButton="true"
          ></page>
        </v-card-text>
      </v-card>
    </div>
    <!-- {{ json }}
    </div> -->
    <v-alert type="error" v-if="error" class="ma-4">
      There was an error downloading data. Please try again later.</v-alert
    >
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
import ResponsiveTable from "@/components/pagesStuff/ResponsiveTable";
import UserMixin from "@/assets/js/UserMixin";
import FiltersMixin from "@/assets/js/cls/FiltersMixin.js";
import Page from "@/components/pagesStuff/Page";

// import GetJsonMixin from "@/assets/js/GetJsonMixin";

export default {
  name: "BillingProtocols",
  components: { ResponsiveTable, Page },
  mixins: [UserMixin, FiltersMixin],

  props: {},
  data: function () {
    return {
      api: "/billing-protocols/all",
      expandAll: false,
      protocols: null,
      meta: null,
      error: null,
      loading: false,
      imgPath: "https://www.eyedock.com/images/pathologies/",
      filters: {
        item: null,
      },
      // justScrolled: false,
      // yPositions: {},
    };
  },
  methods: {
    getData() {
      this.loading = true;
      let params = this.isSubscribed ? "?subscriber=1" : "";
      ApiServices.genericApiCall(this.api, params)
        .then((response) => {
          this.protocols = response.data.protocols;
          this.meta = response.data.meta;
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {
          this.checkForSlug();
          this.loading = false;
        });
    },
    checkForSlug() {
      let id = null;
      let item = this.filters.item;
      if (item) id = item;
      if (id) {
        this.goToId(id);
        // if (item) this.showSectionWit  hTag(id);
      }
    },
    toggleExpandAll() {
      this.expandAll = !this.expandAll;
    },
    setCategoryStore(item) {
      this.$store.dispatch("setModeAndDetail", {
        mode: "slug",
        detail: item,
      });
    },
    goToId(id) {
      // this.goToId = id;
      this.$nextTick(() => {
        let el = document.getElementById(id);
        if (el) this.$vuetify.goTo(el, { offset: 20 });
      });
    },

    // if the user scrolls, check to see what element is being displayed and set the store "detail" to that element. This will update the billingProtocolsMenuBtns to highlight the correct button
    // ! wasn't working...
    // throttledScroll() {
    //   clearTimeout(window.scrollEndTimer);
    //   window.scrollEndTimer = setTimeout(this.handleScroll(), 100);
    //   let that = this;
    //   that.justScrolled = true;
    //   setTimeout(() => {
    //     that.justScrolled = false;
    //   }, 200);
    // },
    handleScroll() {
      // console.log("handleScroll");
      //   let lastSlug = null;
      //   this.allSlugs.forEach((key) => {
      //     let el = document.getElementById(key);
      //     if (el) {
      //       let rect = el.getBoundingClientRect();
      //       if (rect.y > 0 && rect.y < this.viewportHeight) {
      //         lastSlug = key;
      //       }
      //     }
      //   });
      //   if (lastSlug && lastSlug != this.storeDetail)
      this.setCategoryStore(null);
    },
  },
  computed: {
    allSlugs: function () {
      let slugs = this.protocols ? this.protocols.map((p) => p.slug) : [];
      slugs.push("protocols-disclaimer");
      return slugs;
    },
    viewportHeight: function () {
      return window.innerHeight || document.documentElement.clientHeight;
    },
    storeDetail: function () {
      return this.$store.state.detail;
    },
    itemName: function () {
      let item = this.filters.item;
      if (!item) return "";
      let name = item.replace(/-/g, " ");
      return " | " + name;
    },
  },
  watch: {
    // if a button is clicked in billingProtocolsMenuBtns, it sets the "detail" in the store. This will be the item - if it changes, scroll to the correct element (set with id = #slug_name)
    storeDetail(val) {
      // if (this.justScrolled) return; // don't scroll if the user just scrolled, though.
      this.filters.detail = val;
      if (val) {
        this.updateHashWithParamString("item=" + val);
        this.goToId(val);
      }
    },
    isSubscribed() {
      this.getData(); // reload the data if the subscriber status changes
    },
    isMobile() {
      this.expandAll = this.$vuetify.breakpoint.smAndUp;
    },
  },
  mounted() {
    this.prepend_F = false; // (for FiltersMixin)
    this.keysCase = "lower"; // (for FiltersMixin)
    let hashItem = this.hashValForKey("item");
    if (hashItem) this.expandAll = true;
    this.filters.item = hashItem;

    if (hashItem) this.setCategoryStore(hashItem);
    this.getData();

    // window.addEventListener("scroll", this.handleScroll);
    // window.addEventListener("scroll", this.throttledScroll);

    // this.getJSON("billingProtocols", "json"); // in the mixin
  },

  unmounted() {
    // window.removeEventListener("scroll", this.handleScroll);
  },
  metaInfo() {
    return {
      title: "EyeDock/Billing Protocols " + this.itemName,
    };
  },
};
</script>

<style scoped>
.whiteBox {
  background-color: #fff;
  margin-right: 1em;
  border-radius: 3px;
  border: 1px solid gray;
}
</style>
